const pricing = {
  title: '购买 / 升级',
  cycle_month: '月卡',
  cycle_year: '年卡',
  per_month: '/ 月',
  per_year: '/ 年',
  days: '{{count}} 天',
  months: '{{count}}个月',
  original: '原价：{{price}}{{unit}}',
  per_day: '低至 ¥{{price}}/天',
  start_trial: '开通试用',
  current_plan: '当前套餐',
  upgrade: '升级',
  current_badge: '当前',
  purchase_pending: '购买流程即将开放',
  plans_load_failed: '套餐加载失败',
  no_plans: '暂无可展示套餐',
  packages_load_failed: '权益包加载失败',
  no_packages: '暂无可购买权益包',
  permanent: '永久',
  no_price: '当前地区暂无价格',
  select_spec: '选择规格',
  buy: '购买',
  buy_now: '立即购买',
  unavailable: '暂不可购买',
  basic_included: '注册即可使用，无需购买',
  not_supported: '不支持',
  per_day_amount: '低至 {{price}} / 天',
  currency: '币种',
  currency_cny: '人民币',
  pay_method: '支付方式',
  pay_wechat: '微信',
  pay_alipay: '支付宝',
  pay_bank: '对公转账',
  plan_price: '套餐价',
  coupon: '优惠券',
  select_coupon: '选择优惠券',
  pay_amount: '实付金额',
  pay_now: '立即支付',
  agree_terms: '支付即同意《用户协议》',
  benefits: '可享权益',
  pay_channel_unsupported: '当前支付方式暂未开放',
  pay_create_failed: '下单失败',
  pay_waiting: '请完成支付',
  pay_qr_hint: '请使用对应 App 扫码支付',
  pay_open_link: '打开支付页面',
  pay_success: '支付成功',
  pay_failed: '支付失败',
  pay_closed: '支付已关闭',
  pay_polling: '等待支付结果…',
  pay_order_no: '订单号 {{orderNo}}',
  pay_invalid_sku: '请选择有效的价格规格',
  pay_invalid_plan: '缺少套餐编码',
  pay_invalid_package: '缺少权益包编码',
  pay_invalid_amount: '金额无效',
  period_DAY: '天',
  period_WEEK: '周',
  period_MONTH: '月',
  period_TOTAL: '总',
  period_NONE: '持续',
  trial_name: '试用会员',
  trial_desc: '店铺 2 · 邮件 10 封（试用）',
  pro_name: '专业版',
  pro_desc: '店铺 5 · 邮件 3,000 封/月',
  deluxe_name: '豪华版',
  deluxe_desc: '店铺 10 · 邮件 10,000 封/月',
  feat_square: '达人广场',
  feat_dm: '私信',
  feat_mailbox: '平台邮箱',
  feat_shops: '授权店铺',
  feat_trial_all: '试用全部能力',
  feat_script: '话术模板',
  feat_invite: '定向邀约',
  feat_dedupe: '高频防重单',
  feat_email: '邮件额度',
  feat_pro_all: '专业版全部',
  feat_dashboard: '团队数据看板',
  feat_members: '成员管理',
  feat_ticket: '工单优先',
  quota_mail_trial: '10 封',
  quota_mail_pro: '3,000 封/月',
  quota_mail_deluxe: '10,000 封/月',
  quota_shop_2: '2 个',
  quota_shop_5: '5 个',
  quota_shop_10: '10 个'
};

export default pricing;
